<template>
  <b-card>
    <div>
      <h3 class="text-black font-bold">
        Tagihan
      </h3>
    </div>
    <b-table
      class="mt-6 !max-h-[63vh]"
      :fields="fields"
      :items="useFetcher.data"
      :busy="useFetcher.isLoading"
      :loading="useFetcher.isLoading"
      :empty-text="'Tidak ada data tagihan'"
      sticky-header
      show-empty
      responsive
      @scroll.native="handleScroll"
    >
      <template #table-busy>
        <div class="flex justify-center items-center h-full m-2">
          <b-spinner variant="primary" />
        </div>
      </template>
      <template #cell(ref_id)="data">
        <div class="flex gap-2 justify-start items-center">
          <ButtonBayarTagihan
            :invoice-id="data.item.id"
            :ref-id="data.value"
            :from-tagihan="true"
            :disabled="data.item.status === 'PAID'"
            size="sm"
            @on-close="handleClose"
          />
          <span>|</span>
          <router-link
            :to="{ name: 'tagihan-detail', params: { id: data.value }, query: { invoice_id: data.item.id, status: data.item.status } }"
            class="btn btn-outline-danger btn-sm min-w-[130px]"
          >
            Detail Tagihan
          </router-link>
        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
/**
 * Component untuk menampilkan daftar tagihan
 *
 * Component ini menampilkan daftar tagihan yang terdiri dari periode, jenis tagihan, nominal tagihan,
 * dan aksi. Daftar tagihan menggunakan pagination dengan infinite scroll menggunakan usePaginatedFetcher
 * dan @scroll.native.
 */
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import { DaftarInvoiceFields } from './config'
import ButtonBayarTagihan from './components/ButtonBayarTagihan.vue'

export default {
  name: 'Invoice',
  components: {
    ButtonBayarTagihan,
  },
  data() {
    return {
      fields: DaftarInvoiceFields,
      useFetcher: createPaginatedFetcher(this.fetchData),
    }
  },
  mounted() {
    this.useFetcher.fetchData()
  },
  methods: {
    fetchData({ limit, offset }) {
      return this.$http_new.get('/auth/api/v1/user-balance-invoices', {
        params: {
          limit,
          offset,
        },
      }).then(res => {
        const { data } = res.data
        return {
          data,
        }
      }).catch(() => ({
        data: [],
      }))
    },
    handleClose({ isSuccess }) {
      if (isSuccess) {
        this.useFetcher.fetchData({ reset: true })
      }
    },
    handleScroll(event) {
      const { target } = event
      if (target.scrollTop + target.clientHeight >= target.scrollHeight) {
        this.useFetcher.fetchData()
      }
    },
  },
}
</script>
